import GoogleMapsLoader from 'google-maps'
import { find, findFirst } from 'helpers/vanilla'

GoogleMapsLoader.KEY = 'AIzaSyBBGuvxt1EhDPDHzvmQ8to1N5FjO5hxpPg'
GoogleMapsLoader.LANGUAGE = 'de'
GoogleMapsLoader.LIBRARIES = ['geometry', 'places'];

//let placeIds = [{"map_location":"ChIJT7AT1IhZwokRWMZL8xcKMtY"}]
let mapOptions = {
  zoom: 16,
  scaleControl: true,
  scrollwheel: false,
  navigationControl: false,
  mapTypeControl: false,
  scaleControl: false,
  center: {
    lat: 47.1900444,
    lng: 14.7267544,
  },
  styles: [{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]}]
}

const Map = () => {

  const name = 'googlemap'
  let $googlemap

  const loadCondition = () => {
    $googlemap = findFirst('.map')
    return $googlemap
  }

  const init = () => {

    let map
    let mapElement = find('.map')[0]
    //console.log(mapElement)

    GoogleMapsLoader.load((google) => {

      map = new google.maps.Map(document.getElementById('map'), mapOptions)
      // let service = new google.maps.places.PlacesService(map)
      // let noOfPlaces = placeIds.length

       //const createMarker = (marker) => {
        new google.maps.Marker({
          position: {
            lat: 47.1900444,
            lng: 14.7267544,
          },
          map: map,
          icon: themePath + '/assets/images/map_pin.svg', // themePath comes from header.php
          title: 'Schloss Farrach'
        })
      //}
    })

  }

  //init()
  return { loadCondition, name, init }
}

export default Map



// WEBPACK FOOTER //
// public/content/themes/farrach/src/js/components/map.js